import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ProductAllowedQuantityService } from '../../cart/base/components/product-allowed-quantity/core/product-allowed-quantity.service';
import { RoutingService, TranslationService } from '@spartacus/core';
import { ToasterService } from '../../../../components/toaster/toaster.service';
import { TOASTER_TYPE } from '../../../../components/toaster/toaster.model';

@Injectable({
  providedIn: 'root',
})
export class ProductQuantityAllowedGuard {
  constructor(
    private productAllowedQuantityService: ProductAllowedQuantityService,
    protected routingService: RoutingService,
    protected toasterService: ToasterService,
    private translationService: TranslationService,
  ) {}

  canActivate(): Observable<boolean> {
    return this.productAllowedQuantityService.checkProductAllowedQuantity().pipe(
      map(result => {
        const hasValidProductQuantities = result?.productChanges?.length === 0;

        if (result.hasError) {
          this.toasterService.init({
            type: TOASTER_TYPE.DANGER,
            content: result.message!,
          });
        } else {
          if (!hasValidProductQuantities) {
            this.translationService.translate('productQuantityAllowed.invalidQuantities').subscribe((translation: string) => {
              this.toasterService.init({
                type: TOASTER_TYPE.WARNING,
                content: translation,
              });
            });
          }
        }

        if (!hasValidProductQuantities || result.hasError) {
          this.routingService.go({ cxRoute: 'cart' });
        }

        return hasValidProductQuantities;
      }),
    );
  }
}